import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Modal, Button, Form } from "react-bootstrap";
import Login from "../../../components/login/login";
import { PDF, HTML, XML, INFO } from "../../../components/iconsSVG/IconsSVG";
import { useAuth } from "../../../context/AuthContext";
import Calendario from "../../../components/calendario/calendario";
import { format, parse } from "date-fns";
import {
  publicacionesBopi,
  buscarPublicaciones,
  descargarDocumento,
  descargarSumario,
  validarRefrescarToken,
} from "../../../services/publicacionesBopiService";
import "./../DescargaTomosPage.css";
import BotonesBusquedaDescargaTomos from "./botonesBusquedaDescargaTomos";
import { es } from "date-fns/locale"; // Importar el locale para español
import { right } from "@popperjs/core";
import { verAviso } from "../../../components/VerAviso/VerAviso";


const DescargaTomo1 = () => {
  const [show, setShow] = useState(false);
  const [modalContent, setModalContent] = useState(""); // Controla el contenido del modal
  const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);
  const handleShow = (message) => {
    setModalContent(message); // Configura el contenido del modal
    setShow(true); // Muestra el modal
  };
  const {refreshToken, handleLogout, token, user } = useAuth();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [mensajeSumario, setMensajeSumario] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [cveInput, setCveInput] = useState("");
  const [searchMessage, setSearchMessage] = useState("");
  const [fileId, setFileId] = useState(null);
  const [publicacion, setPublicacion] = useState(null);
  const [fechaFormated, setFechaFormateada] = useState("");
  const [mensajeBusqueda, setMensajeBusqueda] = useState("");
  const [fechaBusqueda, setFechaBusqueda] = useState(null);
  const inputRef = useRef(null);

  const cargarFechaInicial = async () => {
    try {
      const publicacion = await publicacionesBopi(1);

      if (publicacion && publicacion.fechaPublicacion) {
        const fechaString = publicacion.fechaPublicacion;

        const parsedDate = parse(fechaString, "yyyy-MM-dd", new Date(), { locale: es });

        const fechaFormateada = format(parsedDate, "d 'de' MMMM 'de' yyyy", { locale: es });

        setFechaBusqueda(parsedDate);
        setFechaFormateada(fechaFormateada);
        setPublicacion(publicacion);

      } else {
        setMensaje("Último BOPI publicado (no encontrado)");
      }
    } catch (error) {
      setMensaje("Último BOPI publicado (no encontrado)");
      console.error("Error cargando fecha inicial:", error);
    }
  };

  useEffect(() => {
    if (fechaBusqueda) {
      handleSearch();
    }
  }, [fechaBusqueda]);

  const descargarSumarioTomo1 = async (tomo) => {
    try {
      setMensajeSumario("Descargando documento...");

      const codigoError = await descargarSumario('1');
      if (codigoError==403) {
        handleLogout();
        setShowLoginModal(true);
      }

      // Actualizar el mensaje después de la descarga
      setMensajeSumario(`Documento descargado correctamente.`);
    } catch (error) {
      setMensajeSumario("Error al descargar el documento.");
      console.error("Error descargando el documento:", error);
    }
  };

  const descargarDocumentoConEstado = async (publicacion, Tipo, token, user) => {
    try {
      // Establecer estado de carga
      setMensaje("Descargando documento...");

      const fechaFormateada = format(fechaBusqueda, "dd-MM-yyyy");
      // Llamada al método de descarga
      const response = await validarRefrescarToken(token, user);
      if (response.token) {
        refreshToken(user,response.token);
      }
      const codigoError = await descargarDocumento(publicacion, Tipo, 1, fechaFormateada, token, user);
      if (codigoError==403) {
        handleLogout();
        setShowLoginModal(true);
      }

      // Actualizar el mensaje después de la descarga
      if (codigoError === 0) setMensaje(`Documento ${Tipo} descargado correctamente.`)
      else setMensaje(`Documento ${Tipo} Error al descargar el documento.`);
    } catch (error) {
      setMensaje("Error al descargar el documento.");
      console.error("Error descargando el documento:", error);
    }
  };

  useEffect(() => {

    cargarFechaInicial();
  }, []);

  const handleShowLoginModal = () => {
    setShowLoginModal(true);
  };

  const handleCloseLoginModal = () => {
    setShowLoginModal(false);
  };

  const handleDateChange = async (date) => {
    setStartDate(date);
  };

  const handleSearch = async () => {
    try {
      setPublicacion("");
      const fechaFormateada = format(fechaBusqueda, "dd-MM-yyyy");
      const diaActual = new Date().toISOString().split('T')[0];
      // const year = parseInt(fechaFormateada.split("-")[2], 10);
      // if (year<2002){
      //   alert("No se permiten búsquedas anteriores al año 2002.");
      //   return;
        if (fechaBusqueda > diaActual){
          // alert("No se permiten búsquedas de días posteriores al actual.");
          verAviso("No se permiten búsquedas de días posteriores al actual.");
          return;
        }
      // } else {
        const publicacionRecuperada = await buscarPublicaciones(
          1,
          fechaFormateada,
          cveInput
        );

        if (publicacionRecuperada) {
          setPublicacion(publicacionRecuperada);

          setMensajeBusqueda(`Publicaciones del día ` + fechaFormateada + ':');
          setMensaje("");
        } else{
          setMensajeBusqueda("");
          setMensaje("No se encontraron resultados para la fecha indicada");
        }
      // }
    } catch (error) {
      console.error("Error en la búsqueda de publicaciones:", error);
      setSearchMessage("Ocurrió un error al buscar publicaciones");
    }
  };

  const handleReset = () => {
    cargarFechaInicial();
    setCveInput("");
    setSearchMessage("");
    setFileId(null);
    setMensajeBusqueda("");
    setMensaje("");
    setMensajeSumario("");
  };

  return (

    <Row className="m-0 p-0 py-4">
      {/* <Col xs="auto" md={1}></Col> */}
      <Col xs={12} md={12} className="m-0 p-0 text-lg-start">
        <div className="m-0 p-0 py-3 espacios-generales shadow position-relative d-flex justify-content-center">
          <div className="pb-4 px-lg-4 d-inline-block text-center">
            <div className="d-inline-block text-start">
              <br></br>
              <Row className="gap-3 px-2">
                <h2 style={{ fontSize: '1.5em' }}>Último BOPI publicado {fechaFormated}</h2>
              </Row>              
              <br></br>
                                       
              <Row className="gap-3 px-2">
                <h3 style={{ fontSize: '1.3em', color: "#356ab3" }}>{mensajeBusqueda}</h3>
              </Row>
              <Row className="gap-3 px-2">
                <h4 style={{ fontSize: '1.1em', color: "#356ab3" }}>{mensaje}</h4>
              </Row>

              <Row className="gap-3 px-2">
                <Col xs="auto" className="d-flex justify-content-start mb-1 mb-lg-0 ">
                <div className="alineacion-btn">

                {/* PDF */}
                <>
                  <button
                    onClick={() => descargarDocumentoConEstado(publicacion, 'PDF', token, user)}
                    className="m-0 p-0 w-auto text-start btn btn-blanco"
                  >
                    <PDF />
                  </button>
                  <tag > Tomo 1 en PDF</tag>
                </>
                {/* XML */}
                {token && (
                  <button
                    onClick={() => descargarDocumentoConEstado(publicacion, 'XML', token, user)}
                    className="m-0 p-0 ms-2 w-auto text-start btn btn-blanco"
                  >
                    <XML />
                  </button>
                )}

                {/* HTML / XML */}
                {token ? (
                  <>
                    <button
                      onClick={() => descargarDocumentoConEstado(publicacion, 'HTML', token, user)}
                      className="m-0 p-0 w-auto text-start btn btn-blanco"
                    >
                      <HTML />
                    </button>
                    <tag > Tomo 1 en XML y HTML</tag>
                  </>
                ) : (
                  <>
                    <button
                      className="m-0 p-0 ms-2 w-auto text-start btn btn-blanco"
                      onClick={handleShowLoginModal}
                    >
                      <XML /> <HTML />
                    </button>
                    <tag > Tomo 1 en XML y HTML</tag>
                  </>
                )}

                {/* INFO */}
                <Button
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                  }}
                  className="pt-1 fondo-blanco-icono info"
                  onClick={() =>
                    handleShow("Inicia sesión para descargar el BOPI en formato XML y HTML y haz click en el icono correspondiente")
                  }
                >
                  <INFO color_icono="#203C77" color_fondo="transparent" />
                </Button>

                </div>
                
                </Col>
              </Row>
              <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>{modalContent}</Modal.Body>
              </Modal>
              <Modal show={showLoginModal} onHide={handleCloseLoginModal}>
                <Modal.Header closeButton>
                  <Modal.Title>Acceso requerido</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Login />
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleCloseLoginModal}>
                    Cerrar
                  </Button>
                </Modal.Footer>
              </Modal>

              {/* <Row className="gap-3">
                <Form.Group className="mb-3" controlId="formBasicDate">
                  {(startDate ?
                    <Calendario selected={startDate} onDateChange={handleDateChange} /> :
                    <Calendario selected={null} onDateChange={handleDateChange} />
                  )}
                </Form.Group>
              </Row> */}
              <Form onSubmit={(e) => { e.preventDefault(); handleSearch(); }}
                    onKeyDown={(e) => {if (e.key === "Enter") {e.preventDefault(); handleSearch(); }}}>
                <Row className="gap-3 px-2">
                  <Form.Group className="mb-3" controlId="formBasicDate">
                    <Form.Control 
                      ref={inputRef}
                      style={{ width: '45%' }}
                      className="mb-3 date-picker-only"
                      type="date"
                      value={fechaBusqueda}
                      onChange={(e) => setFechaBusqueda(e.target.value)}
                      max={new Date().toISOString().split('T')[0]}
                      onKeyDown={(e) => e.preventDefault()}
                      onPaste={(e) => e.preventDefault()}
                      onClick={() => inputRef.current?.showPicker()}
                      />
                    
                  </Form.Group>
                </Row>

                <Row className="gap-3 px-2">
                  <Col>
                    <Form.Group className="mb-3 text-break" controlId="BuscadorCVE">
                      <Form.Label>Buscador por CVE</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="CVE-BOPI-TX-AAAAMMDD-XXXXXXXX"
                        value={cveInput}
                        onChange={(e) => setCveInput(e.target.value)}

                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
              <br />
              {/* <div className="d-grid gap-2 d-flex justify-content-center"> */}
            </div>
            <Row className="gap-3 px-2">
              <Col xs="auto" className="w-100 d-flex justify-content-center mb-1 mb-lg-0 ">
                <a href="https://sede.oepm.gob.es/eSede/datos/es/catalogo/catalogo-de-otros-datos-bopi-cip/">
                  <Button size="md" className="btn btn-blue-border w-100 text-uppercase">
                    Descarga de plantillas XSD para el proceso automatizado de los tomos
                  </Button>
                </a>
                
                  <button 
                      onClick={() => descargarSumarioTomo1('1')}
                      className="m-0 mt-1 w-auto text-start btn btn-blanco">
                      <PDF /> SUMARIO Tomo 1{" "}
                    </button>
                    
              </Col>
            </Row>
            <Row className="gap-3" ><h4 style={{ fontSize: '1.1em' , padding:'1%', textAlign: 'right'}}>{mensajeSumario}</h4></Row>
          </div>
          {/* <Button
            style={{
              backgroundColor: "transparent", //"#203C77",
              border: "none",
            }}
            className="position-absolute text-end top-0 end-0 m-2 pt-1 fondo-blanco-icono info"
            onClick={() => handleShow("Búsqueda para la descarga de PDF, HTML y XML a partir de una fecha o de un CVE")}>
            <INFO color_icono="#203C77" color_fondo="transparent" className="p-0 m-0" />
          </Button> */}
        </div>
        <br />
        <div className="d-flex flex-row justify-content-center">
          <BotonesBusquedaDescargaTomos
            onSearch={handleSearch}
            onReset={handleReset}
          />
          <br />
        </div>
        <div>
          <br />
          <p>{searchMessage}</p>
        </div>
        <br />
      </Col>
      {/* <Col xs="auto" md={1}></Col> */}
    </Row>
  );
};

export default DescargaTomo1;
